import Script from "next/script";

const SWIPER_CSS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
const SWIPER_JS_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

export const InsiderTag = () => {
    return (
        <>
            <link rel="stylesheet" href={SWIPER_CSS_URL} />
            <Script src={SWIPER_JS_URL} strategy="afterInteractive" />
            <Script
                id="insiderTag"
                src={`https://${process.env.NEXT_PUBLIC_INSIDER_TAG_MARKET}.api.useinsider.com/ins.js?id=${process.env.NEXT_PUBLIC_INSIDER_TAG_ID}`}
                strategy="afterInteractive"
            />
        </>
    );
};
